<template>
    <div class="search-contents-wrap _hashtags">

        <button type="button" class="mobile-back-btn" v-on:click="mobileSearchBack">
            <div class="md_icon-btn _small">
                <div class="inner"><SvgIconBack /></div>
            </div>
            <p>BACK</p>
        </button>

        <div class="scroll-inner">
            <div class="search-contents-inner">

                <div class="item-wrap">

                    <div class="item form_hashtag" v-for="(hashtag,index) in $store.state.search.set.hashtags" v-bind:key="index">
                        <input type="checkbox" name="search-hashtag" :id="'search-hashtag' + index" value="" v-on:change="changeHashtag(hashtag)">
                        <label :for="'search-hashtag' + index" class="btn_common">
                            <div class="md_svg-icon">
                                <SvgIconHashTag />
                            </div>
                            <span>{{ hashtag.name }}</span>
                            <div class="number"><span>{{ hashtag.brand_hashtag }}</span></div>
                        </label>
                    </div>

                </div><!--/.item-wrap-->

            </div>
        </div>
    </div><!--/.search-contents-wrap._category-->
</template>

<script>

    //SvgIcon
    import SvgIconSearch from '@/components/EndUser/svg/SvgIconSearch'
    import SvgIconHashTag from '@/components/EndUser/svg/SvgIconHashTag'
    import SvgIconBack from '@/components/EndUser/svg/SvgIconBack'

    export default {
        components: {
            //SvgIcon
            SvgIconBack,
            SvgIconSearch,
            SvgIconHashTag,
        },
        data() {
            return {
                hashtags: [],
            }
        },
        methods: {
            ////////////////////////////////////
            //検索メニューMobile表示Backボタン
            ////////////////////////////////////
            mobileSearchBack: function () {
                this.tabSelectorActive = '';
                for (const element of document.getElementsByName('search-select')) {
                    element.checked = false;
                }
            },
            changeHashtag(hashtag) {

                var itemIndex = '';
                var itemCheck = true;

                this.hashtags.forEach(function(item, index){
                    if (item.name == hashtag.name) {
                        itemIndex = index;
                        itemCheck = false;
                    }
                });

                if (!itemCheck){
                    this.hashtags.splice(itemIndex, 1)
                } else {
                    this.hashtags.push(hashtag.name)
                }

                this.$store.state.search.form.hashtags = this.hashtags;
            }
        }
    }
</script>
